// store.ts
import { configureStore } from "@reduxjs/toolkit";
import amount from "./Prices/reducer";

export const store = configureStore({
  reducer: { amount },
});
